// register-validators.js
import { validatorRegistry } from "./validator-registry";
import { RequiredValidator } from "./validators/required-validator";
import { EmailValidator } from "./validators/email-validator";
import { PhoneValidator } from "./validators/phone-validator";
import { NumberValidator } from "./validators/number-validator";
import { MinLengthValidator } from "./validators/min-length-validator";
import { MaxLengthValidator } from "./validators/max-length-validator";
import { MinValueValidator } from "./validators/min-value-validator";
import { MaxValueValidator } from "./validators/max-value-validator";
import { RegexValidator } from "./validators/regex-validator";
import { ZipCodeValidator } from "./validators/zip-code-validator";
import { DateRangeValidator } from "./validators/date-range-validator";
import { IntegerOnlyValidator } from "./validators/integer-only-validator";
import { FloatOnlyValidator } from "./validators/float-only-validator";

// Register standard validators
validatorRegistry
    .register("required", new RequiredValidator())
    .register("email", new EmailValidator())
    .register("phone", new PhoneValidator())
    .register("number", new NumberValidator())
    .register("minLength", new MinLengthValidator())
    .register("maxLength", new MaxLengthValidator())
    .register("minValue", new MinValueValidator())
    .register("maxValue", new MaxValueValidator())
    .register("regex", new RegexValidator())
    .register("zipCode", new ZipCodeValidator())
    .register("dateRange", new DateRangeValidator())
    .register("integerOnly", new IntegerOnlyValidator())
    .register("floatOnly", new FloatOnlyValidator());

// Add more registrations as needed
